import { getSellers } from '@/services/oto/sellers';
export async function fetchSellersList(filters, orderBy, page, limit, statusFilter) {
    const args = {
        ...(filters.length && { query: JSON.stringify(filters) }),
        ...(statusFilter !== null && { enabled: statusFilter }),
        orderBy,
        page,
        limit,
    };
    const data = await getSellers(args.limit, args.page, args);
    return formatResponse(data);
}
function formatResponse(data) {
    return {
        sellers: data?.data?.map((sellerTuple) => {
            return Object.fromEntries(sellerTuple.map((fieldValue, fieldIndex) => {
                return [data.series[fieldIndex].key, fieldValue];
            }));
        }) || [],
        hasSellersWarning: data?.hasSellersWarning || false,
        totalCount: data.totalCount || 0,
    };
}
